import { Button } from './button';
import { Dialog } from './dialog';

/**
 * Figma P01 "Session expired": a calm dialog, not an error. "Sign in again" is the way forward, "Not now" leaves the
 * page as it is. `draftKept` adds the line about an unsaved draft, but only when a screen really kept one on this device.
 */
export function SessionExpiredDialog({
  open,
  onSignIn,
  onDismiss,
  draftKept = false,
}: {
  open: boolean;
  onSignIn: () => void;
  onDismiss: () => void;
  draftKept?: boolean;
}) {
  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      density="confirm"
      title="You’ve been signed out"
      description={`For your safety we sign you out after 12 hours without activity.${draftKept ? ' Your unsaved draft is kept on this device.' : ''}`}
      footer={
        <>
          <Button variant="secondary" size="dialog" onClick={onDismiss}>
            Not now
          </Button>
          <Button size="dialog" onClick={onSignIn}>
            Sign in again
          </Button>
        </>
      }
    />
  );
}
